export const environment = {
  production: true,
  urlApi: 'https://api-pxy.denario.com.co/api/',
  Authorization:'AutDenarioPro2021'
};
